<div class="reportspage">

  <div class="sidebar">
    <h2>Reports </h2>
  </div>

  <div class="resultscontainer">

    <div class="toolbar" style="justify-content: flex-start; margin-top: 10px;">

      <div class="form-group" style="width: 140px;">
        <div class="input-group input-group-sm">
          <input class="form-control" placeholder="yyyy-mm-dd" readonly name="dp1" [(ngModel)]="from" ngbDatepicker
            #d1="ngbDatepicker" (dateSelect)="setFrom($event)">
          <div class="input-group-append">
            <button class="btn btn-outline-secondary " (click)="d1.toggle()" type="button"><i
                class="fas fa-calendar-alt"></i></button>
          </div>
        </div>
      </div>

      <div class="form-group" style="width: 140px;">
        <div class="input-group input-group-sm">
          <input class="form-control" placeholder="yyyy-mm-dd" readonly name="dp2" [(ngModel)]="until" ngbDatepicker
            #d2="ngbDatepicker" (dateSelect)="setUntil($event)">
          <div class="input-group-append">
            <button class="btn btn-outline-secondary " (click)="d2.toggle()" type="button"><i
                class="fas fa-calendar-alt"></i></button>
          </div>
        </div>
      </div>

      <div class="form-group" style="width: 140px;">
        <div class="input-group input-group-sm">
          <a class="btn btn-outline-secondary" style="white-space: nowrap;" [href]="getReportUrl()">
            <i class="fas fa-file"></i>&nbsp;&nbsp;Generate Report</a>
        </div>
      </div>

    </div>

  </div>
</div>